import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import { useBreadcrumbForAd, type AutoData, type MotoData } from '@sbt-web/breadcrumbs';
import { CategoryID, GeoEntry } from '@sbt-web/network/types';
import { TuttaItalia } from '@sbt-web/utils';
import type { SearchState } from '@/reducers/search';
import { bodyValuesToName, fuelValuesToName, makeValuesToName, modelValuesToName } from '@/shared/tools/search/pretty-urls/redirection-maps/auto';
import { adTypesLabelsMap, adTypesToSlugMap } from '@/shared/tools/search/values';
import ownClasses from './ListingBreadcrumbs.module.scss';
const autoDataFromFilters = (filters: Record<string, string>, filtersLabels: Record<string, string>): AutoData => {
  const [brand, model, type, fuel] = ([['cb', makeValuesToName], ['cm', modelValuesToName], ['ct', bodyValuesToName], ['fl', fuelValuesToName]] as [string, Map<string, string>][]).map(([keyName, valueNameMap]) => {
    if (keyName in filters && keyName in filtersLabels && valueNameMap.has(filters[keyName])) {
      return {
        label: filtersLabels[keyName],
        value: valueNameMap.get(filters[keyName]) as string
      };
    }
    return undefined;
  });
  return {
    for: 'auto',
    brand,
    model,
    type,
    fuel
  };
};
const motoDataFromFilters = (filters: Record<string, string>, filtersLabels: Record<string, string>): MotoData => {
  const [brand, model, type] = ['bb', 'bm', 'mt'].map(parameterName => {
    if (parameterName in filters) {
      return {
        id: filters[parameterName],
        label: filtersLabels[parameterName],
        parameterName
      };
    } else {
      return undefined;
    }
  });
  return {
    for: 'moto',
    brand,
    model,
    type
  };
};
interface Props {
  search: SearchState;
}
const ListingBreadcrumbs: FC<Props> = t0 => {
  const $ = _c(19);
  const {
    search
  } = t0;
  let vehicleData = undefined;
  if (search.category.id === CategoryID.Auto) {
    let t1;
    if ($[0] !== search.filters || $[1] !== search.filtersLabels) {
      t1 = autoDataFromFilters(search.filters, search.filtersLabels);
      $[0] = search.filters;
      $[1] = search.filtersLabels;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    vehicleData = t1;
  } else {
    if (search.category.id === CategoryID.Moto) {
      let t1;
      if ($[3] !== search.filters || $[4] !== search.filtersLabels) {
        t1 = motoDataFromFilters(search.filters, search.filtersLabels);
        $[3] = search.filters;
        $[4] = search.filtersLabels;
        $[5] = t1;
      } else {
        t1 = $[5];
      }
      vehicleData = t1;
    }
  }
  let selectedGeo = search.geo;
  if (search.geo.region.id === TuttaItalia.id) {
    selectedGeo = undefined;
  }
  const t1 = adTypesLabelsMap[search.adType];
  const t2 = adTypesToSlugMap[search.adType];
  let t3;
  if ($[6] !== search.adType || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      id: search.adType,
      label: t1,
      parameterName: t2
    };
    $[6] = search.adType;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== search.category.id || $[11] !== search.query || $[12] !== selectedGeo || $[13] !== t3 || $[14] !== vehicleData) {
    t4 = {
      assetsBase: process.env.NEXT_PUBLIC_ASSETS_BASE_URL,
      adTypeData: t3,
      origin: process.env.NEXT_PUBLIC_ENV_BASE_URL,
      categoryId: search.category.id,
      searchQuery: search.query,
      geo: selectedGeo,
      vehicleData
    };
    $[10] = search.category.id;
    $[11] = search.query;
    $[12] = selectedGeo;
    $[13] = t3;
    $[14] = vehicleData;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const {
    breadcrumbs
  } = useBreadcrumbForAd(t4);
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classnames("breadcrumbs-listing-container", ownClasses["breadcrumbs-listing-container"]);
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== breadcrumbs) {
    t6 = <div className={t5}>{breadcrumbs}</div>;
    $[17] = breadcrumbs;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default ListingBreadcrumbs;